/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const getRaces = params => hmsAPI.get('/races', { params })
export const getRace = raceId => hmsAPI.get(`/races/${raceId}`)
export const updateRace = (raceId, data) => hmsAPI.put(`/races/${raceId}`, data)
